"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
function rejectWithMessage(error) {
    return Promise.reject(error.message);
}

exports["default"] = function (key, replacer, reviver) {
    return {
        load: function load() {
            return new Promise(function (resolve) {
                var jsonState = localStorage.getItem(key);
                resolve(JSON.parse(jsonState, reviver) || {});
            })["catch"](rejectWithMessage);
        },
        save: function save(state) {
            return new Promise(function (resolve) {
                var jsonState = JSON.stringify(state, replacer);
                localStorage.setItem(key, jsonState);
                resolve();
            })["catch"](rejectWithMessage);
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-storage-engine-localstorage/build/index.js
// module id = 1526
// module chunks = 0